export default __webpack_public_path__ + "static/media/Cauldron2.31de26b6.png";